import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import DownloadGpx from "./DownloadGpx";

const styles = {
  downloadGpxButton: {
    fontSize: 20
  }
};

class DownloadGpxButton extends Component {
  state = {
    isDownloading: false
  };

  static propTypes = {
    classes: PropTypes.object.isRequired,
    geojson: PropTypes.object.isRequired
  };

  render() {
    const { isDownloading } = this.state;
    const { classes, geojson } = this.props;
    return isDownloading ? (
      <DownloadGpx
        geojson={geojson}
        render={({ isLoading, error, errorMessage }) => {
          if (error) {
            return (
              <div className={classes.center}>
                <div>{errorMessage}</div>
                <Button
                  variant="raised"
                  className={classes.newRouteButton}
                  onClick={() => {
                    this.setState({ isDownloading: false });
                  }}
                >
                  Ok
                </Button>
              </div>
            );
          }
          return isLoading ? (
            <div className={classes.loader}>
              <CircularProgress size={80} thickness={7} />
            </div>
          ) : (
            this.setState({ isDownloading: false }) + null
          );
        }}
      />
    ) : (
      <span className={classes.root}>
        <Button
          variant="fab"
          className={classes.downloadGpxButton}
          onClick={() => {
            this.setState({ isDownloading: true });
          }}
        >
          GPX
        </Button>
      </span>
    );
  }
}

export default withStyles(styles)(DownloadGpxButton);



// WEBPACK FOOTER //
// ./src/NewRoute/components/DownloadGpxButton.js